import styles from './Sidebar.css'
import SubHeader from './SubHeader'

const Sidebar = (props) => {
  const { children } = props
  return (
    <div className={styles.sticky}>
      <div className={styles.topItems}>
        <SubHeader />
        {children}
      </div>
      <div className={styles.bottomItems} />
    </div>
  )
}

export default Sidebar
